import { HttpClient } from '@angular/common/http';
import { delay, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as tripFinderActions from '@ibe/store/actions/trip-finder.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common/http";
var TripFinderService = /** @class */ (function () {
    function TripFinderService(store, http) {
        this.store = store;
        this.http = http;
        this.jsonURL = 'assets/data/trip-finder.data.json';
    }
    TripFinderService.prototype.getResults = function () {
        return this.http.get(this.jsonURL).pipe(delay(5000), map(function (res) { return res; }));
    };
    Object.defineProperty(TripFinderService.prototype, "budgetOptions", {
        get: function () {
            return [
                { value: 1, label: '< 50 €' },
                { value: 2, label: '< 100 €' },
                { value: 3, label: '< 200 €' },
                { value: 4, label: '< 300 €' },
                { value: 5, label: '< 400 €' },
                { value: 6, label: '< 500 €' },
                { value: 7, label: 'Any price' },
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TripFinderService.prototype, "regionOptions", {
        get: function () {
            return [
                {
                    id: 'europe',
                    label: 'Europe',
                    countries: ['AT', 'PL', 'ES', 'RU', 'NL', 'IT', 'GR', 'DE', 'GB', 'FR', 'BE', 'CH', 'HU', 'RO', 'DK', 'IE', 'FI', 'UA', 'NO', 'CY', 'PT', 'SI', 'MT', 'CZ', 'BG', 'SE', 'GE', 'EE', 'HR'],
                    selected: 0
                },
                {
                    id: 'south_central_america',
                    label: 'South and Central America',
                    countries: ['BR', 'AW', 'CO', 'MX', 'CL', 'CR'],
                    selected: 0
                },
                {
                    id: 'north_america',
                    label: 'North America',
                    countries: ['US', 'CA', 'BM'],
                    selected: 0
                },
                {
                    id: 'africa',
                    label: 'Africa',
                    countries: ['ZA', 'AO'],
                    selected: 0
                },
                {
                    id: 'asia_oceania',
                    label: 'Asia and Oceania',
                    countries: ['IL', 'NZ', 'CN', 'TH', 'IN', 'AU', 'JP', 'LK', 'SA', 'VN', 'HK', 'NP', 'KR', 'TW'],
                    selected: 0
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Filters the data width the givem SearchParameters
     */
    TripFinderService.prototype.filter = function (obj, searchCriteria) {
        if (!searchCriteria)
            return obj;
        if (searchCriteria.from) {
            obj = obj.filter(function (item) {
                return item.destination.name !== searchCriteria.from['location'].city;
            });
        }
        switch (searchCriteria.to.type) {
            case 'anywhere':
                break;
            case 'country':
                obj = obj.filter(function (item) {
                    return item.destination.country === searchCriteria.to.label;
                });
                break;
            case 'multiple':
                var res_1 = [];
                searchCriteria.to.selected.forEach(function (country) {
                    res_1 = res_1.concat(obj.filter(function (item) {
                        return item.destination.country === country.country;
                    }));
                });
                obj = res_1;
        }
        if (searchCriteria.budget) {
            var budgetValue_1 = this.budgetOptions[searchCriteria.budget].label;
            if (budgetValue_1 !== 'Any price') {
                obj = obj.filter(function (item) {
                    var operator = budgetValue_1.charAt(0);
                    var value = parseInt(budgetValue_1.substring(1), 10);
                    return operator === '<' ? item.minPrice <= value : item.minPrice > value;
                });
            }
        }
        /* duration -> to define....
                if (searchCriteria.duration)
                    obj.filter(item => {
                        const operator = searchCriteria.duration.charAt(0);
                        const value = parseInt(searchCriteria.duration.substring(1), 10);
                        return operator === '<' ? item. <= value : item. > value;
                    });*/
        if (searchCriteria.theme)
            if (searchCriteria.theme.length > 0)
                obj = obj.filter(function (item) {
                    var themes = item.destination.theme;
                    return themes.filter(function (theme) { return searchCriteria.theme.filter(function (elem) { return elem === theme; }).length > 0; }).length > 0;
                });
        return obj;
    };
    TripFinderService.prototype.getOffers = function (searchCriteria) {
        var _this = this;
        this.store.dispatch(new tripFinderActions.Loading);
        this.getResults().subscribe(function (data) {
            var temp = _this.filter(data, searchCriteria);
            _this.store.dispatch(new tripFinderActions.PutOffers(temp));
        });
    };
    /**
     * sort the data by price
     *
     * @param searchCriteria
     */
    TripFinderService.prototype.sortOffersByPrice = function (searchCriteria) {
        var _this = this;
        this.store.dispatch(new tripFinderActions.Loading);
        this.getResults().subscribe(function (data) {
            data.sort(function (a, b) { return a.minPrice - b.minPrice; });
            var temp = _this.filter(data, searchCriteria);
            _this.store.dispatch(new tripFinderActions.PutOffers(temp));
        });
    };
    TripFinderService.prototype.sortOffersByTotal = function (searchCriteria) {
        var _this = this;
        this.store.dispatch(new tripFinderActions.Loading);
        this.getResults().subscribe(function (data) {
            data.sort(function (a, b) { return b.total - a.total; });
            var temp = _this.filter(data, searchCriteria);
            _this.store.dispatch(new tripFinderActions.PutOffers(temp));
        });
    };
    TripFinderService.prototype.sortOffersByName = function (searchCriteria) {
        var _this = this;
        this.store.dispatch(new tripFinderActions.Loading);
        this.getResults().subscribe(function (data) {
            data.sort(function (a, b) { return a.destination.name.localeCompare(b.destination.name); });
            var temp = _this.filter(data, searchCriteria);
            _this.store.dispatch(new tripFinderActions.PutOffers(temp));
        });
    };
    TripFinderService.ngInjectableDef = i0.defineInjectable({ factory: function TripFinderService_Factory() { return new TripFinderService(i0.inject(i1.Store), i0.inject(i2.HttpClient)); }, token: TripFinderService, providedIn: "root" });
    return TripFinderService;
}());
export { TripFinderService };
